import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgCheckIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M52.538 16.878 33.012 46.557a3.2 3.2 0 0 1-2.673 1.441H25.55a3.2 3.2 0 0 1-2.458-1.151l-11.52-13.825 2.458-2.048 11.52 13.824h4.788l19.526-29.68z"
    />
  </svg>
)
export default SvgCheckIcon
